import unfetch from "unfetch";

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    withCredentials: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      response: null
    };
  },
  created() {
    unfetch(this.url, { credentials: this.withCredentials ? "include" : null })
      .then(response =>
        response.json().then(data => ({ data, status: response.status }))
      )
      .then(response => {
        this.response = response;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  },
  render() {
    return this.$scopedSlots.default({
      data: this.response && this.response.data,
      status: this.response && this.response.status,
      loading: this.loading
    });
  }
};
